import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container , Grid } from 'semantic-ui-react';
import TopBar from '../components/topBar';
import Footer from '../components/footer';
import PricingMenu from './price/priceMenu';
import HardwareDisplay from './price/hardwareDisplay';
import SoftwareDisplay from './price/softwareDisplay';
import ServiceDisplay from './price/serviceDisplay';
import QuoteDisplay from './price/quoteDisplay';

class PricingPage extends Component {
  componentDidMount() {
    const { mixpanel } = this.props;
    mixpanel.track('Pricing Page',{ action : 'browse' });
    window.scrollTo(0,0);
  }
  render() {
    const { location } = this.props;
    const { query } = location;
    return (
      <div>
        <TopBar/>
        <Grid stackable style={{ backgroundColor : 'white' , minHeight : '80vh' , margin : 0 }}>
          <PricingMenu priceTarget={query.target}/>
          <Grid.Row columns='2' style={{ minHeight : '80vh' , marginBottom : '20vh' }}>
            <QuoteDisplay/>
            {(query.target === 'hardware') ? <HardwareDisplay/> : null}
            {(query.target === 'software') ? <SoftwareDisplay/> : null}
            {(query.target === 'service') ? <ServiceDisplay/> : null}
          </Grid.Row>
        </Grid>
        <Footer/>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mixpanel : state.ui.tempData.mixpanel
  }
}

export default connect(mapStateToProps,null)(PricingPage)



/** WEBPACK FOOTER **
 ** ./src/containers/pricingPage.js
 **/